import React from 'react';
import { HashRouter, Route } from 'react-router-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import jwtDecode from 'jwt-decode';

import MediaQuery from 'react-responsive';

import ProtectedRoute from './routes/ProtectedRoute';
import AdminRoute from './routes/AdminRoute';

import AuthPage from './pages/AuthPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import VerifyAccount from './pages/VerifyAccount.jsx';

import LandingDesktop from './desktop/landing/LandingDesktopPage';
import ProfilePageDesktop from './desktop/ProfilePageDesktop';
import CourseInfoPage from './desktop/courses/CourseInfoPage';
import CoursesPage from './desktop/courses/CoursesPage';

import AdminPage from './admin/AdminPage';
import AdminCoursesPage from './admin/courses/AdminCoursesPage';
import EditCoursePage from './admin/courses/EditCoursePage';
import AdminUsersPage from './admin/users/AdminUsersPage';
import AdminUserCoursesPage from './admin/users/AdminUserCoursesPage';
import AdminRequestsPage from './admin/requests/AdminRequestsPage';
import AdminWebinarsPage from './admin/webinars/AdminWebinarsPage';
import AdminPaymentsPage from './admin/users/payments/AdminPaymentsPage';
import AdminUserTimetablePage from './admin/users/timetable/AdminUserTimetablePage';

import MainPageMobile from './mobile/main/MainPageMobile';
import AuthPageMobile from './mobile/auth/AuthPageMobile';
import ForgotPasswordPageMobile from './mobile/auth/ForgotPasswordPageMobile';
import ResetPasswordPageMobile from './mobile/auth/ResetPasswordPageMobile';
import ProfilePageMobile from './mobile/profile/ProfilePageMobile';
import CoursesPageMobile from './mobile/courses/CoursesPageMobile';
import CourseInfoPageMobile from './mobile/courses/CourseInfoPageMobile';

import redures from '../reducers';
import actions from '../actions';
import AdminCourseRequestsPage from './admin/course-requests/AdminCourseRequestsPage';
import AdminEditWebinarPage from './admin/webinars/AdminEditWebinarPage';
import AdminEditPaymentPage from './admin/users/payments/AdminEditPaymentPage';
// import Maintenance from './common/Maintenance';

const store = createStore(redures);

// TODO move it to service
const token = localStorage.getItem('token');

if (token) {
  const decoded = jwtDecode(token);

  if (new Date(decoded.exp * 1000) < new Date()) {
    localStorage.removeItem('token');
  } else {
    store.dispatch(actions.authSuccess(token));
  }
}

const App = () => {
  return (
    <Provider store={store}>
      {/* <Maintenance /> */}
      <MediaQuery minDeviceWidth={768}>
        <HashRouter>
          <Route exact path="/" component={LandingDesktop} />
          <Route path="/course/:id" component={CourseInfoPage} />
          <Route path="/courses" component={CoursesPage} />

          <Route path="/auth" component={AuthPage} />
          <Route path="/forgot-password" component={ForgotPasswordPage} />
          <Route exact path="/resetPassword/:token" component={ResetPasswordPage} />
          <Route exact path="/verifyAccount/:token" component={VerifyAccount} />

          <ProtectedRoute path="/profile" component={ProfilePageDesktop} />

          <AdminRoute exact path="/admin" component={AdminPage} />
          <AdminRoute exact path="/admin/courses" component={AdminCoursesPage} />
          <AdminRoute path="/admin/courses/add" component={EditCoursePage} />
          <AdminRoute path="/admin/courses/edit/:id" component={EditCoursePage} />
          <AdminRoute exact path="/admin/users" component={AdminUsersPage} />
          <AdminRoute path="/admin/users/:userId/courses" component={AdminUserCoursesPage} />
          <AdminRoute path="/admin/users/:userId/timetable" component={AdminUserTimetablePage} />
          <AdminRoute exact path="/admin/users/:userId/payments" component={AdminPaymentsPage} />
          <AdminRoute path="/admin/users/:userId/payments/add" component={AdminEditPaymentPage} />
          <AdminRoute path="/admin/users/:userId/payments/:paymentId/edit" component={AdminEditPaymentPage} />
          <AdminRoute path="/admin/requests" component={AdminRequestsPage} />
          <AdminRoute path="/admin/course-requests" component={AdminCourseRequestsPage} />
          <AdminRoute exact path="/admin/webinars" component={AdminWebinarsPage} />
          <AdminRoute path="/admin/webinars/add" component={AdminEditWebinarPage} />
          <AdminRoute path="/admin/webinars/:id/edit" component={AdminEditWebinarPage} />
        </HashRouter>
      </MediaQuery>
      <MediaQuery maxDeviceWidth={767}>
        <HashRouter>
          <Route exact path="/" component={MainPageMobile} />
          <Route exact path="/auth" component={AuthPageMobile} />
          <Route path="/forgot-password" component={ForgotPasswordPageMobile} />
          <Route exact path="/resetPassword/:token" component={ResetPasswordPageMobile} />

          <Route exact path="/courses" component={CoursesPageMobile} />
          <Route path="/courses/:courseId" component={CourseInfoPageMobile} />

          <ProtectedRoute path="/profile" component={ProfilePageMobile} />
        </HashRouter>
      </MediaQuery>
    </Provider>
  );
};

export default App;
